import { render, staticRenderFns } from "./MsgTemplateModal.vue?vue&type=template&id=f1e8bdec&"
import script from "./MsgTemplateModal.vue?vue&type=script&lang=js&"
export * from "./MsgTemplateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports